import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]




export default /*@__PURE__*/_defineComponent({
  __name: 'dataField',
  props: {
    labelText: {
        type: String,
        default: ''
    },
    leftImage: {
        type: String,
    },
    content: {
        type: String,
    },
},
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, { class: "field_row" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "3",
          class: "icon_image"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: props.leftImage,
              alt: ""
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "11",
          class: "label"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.labelText), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "10",
          class: "content"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.content), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})